import { connect } from "react-redux";
import PremierHero from "../../components/PremierHero/index.jsx";
import { getSubscriptionMessage } from "../../utils/subscriptionMessages";

const mapStateToProps = (state) => ({
  apiTitle:
    state.SubscriptionPlans.status === "success" &&
    state.SubscriptionPlans.plans[0]
      ? getSubscriptionMessage(state.SubscriptionPlans.plans[0], "Title")
      : "",
});

export default connect(mapStateToProps)(PremierHero);
